import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * Reusable feedback modal for success, error, or confirmation messages
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether the modal is visible
 * @param {function} props.onHide - Function to call when the modal is closed
 * @param {string} props.title - Modal title
 * @param {string} props.message - Modal message content
 * @param {string} props.variant - Button variant (success, danger, primary, etc.)
 * @param {string} props.type - Modal type (success, error, warning, info, confirmation)
 * @param {function} props.onConfirm - Function to call when confirm button is clicked (for confirmation modals)
 * @param {string} props.confirmText - Text for the confirm button
 * @param {string} props.cancelText - Text for the cancel button
 */
const FeedbackModal = ({ 
  show, 
  onHide, 
  title, 
  message, 
  variant = 'success', 
  type = 'success',
  onConfirm,
  confirmText = 'OK',
  cancelText = 'Cancel'
}) => {
  // Determine if this is a confirmation modal that needs two buttons
  const isConfirmation = type === 'confirmation';
  
  // Set icon and color based on type
  let headerClass = '';
  switch (type) {
    case 'success':
      headerClass = 'bg-success text-white';
      break;
    case 'error':
      headerClass = 'bg-danger text-white';
      variant = 'danger';
      break;
    case 'warning':
      headerClass = 'bg-warning text-dark';
      variant = 'warning';
      break;
    case 'info':
      headerClass = 'bg-info text-white';
      variant = 'info';
      break;
    case 'confirmation':
      headerClass = 'bg-primary text-white';
      variant = 'primary';
      break;
    default:
      headerClass = 'bg-success text-white';
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className={headerClass}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
      </Modal.Body>
      <Modal.Footer>
        {isConfirmation && (
          <Button variant="secondary" onClick={onHide}>
            {cancelText}
          </Button>
        )}
        <Button 
          variant={variant} 
          onClick={isConfirmation ? onConfirm : onHide}
        >
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FeedbackModal;
